import bbobHTML from '@bbob/html'
import presetHTML5 from '@bbob/preset-html5'
import { getUniqAttr, isStringNode, isTagNode } from '@bbob/plugin-helper/lib/index'
import TagNode from '@bbob/plugin-helper/lib/TagNode'

const replaceHtmlTags = (match) => {
  return match.replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

const isStartsWith = (node, type) => (node[0] === type)

const asListItems = (content) => {
  let listIdx = 0
  const listItems = []

  const createItemNode = () => TagNode.create('li')

  const ensureListItem = (val) => {
    listItems[listIdx] = listItems[listIdx] || val
  }

  const addItem = (val) => {
    if (listItems[listIdx] && listItems[listIdx].content) {
      listItems[listIdx].content = listItems[listIdx].content.concat(val)
    } else {
      listItems[listIdx] = listItems[listIdx].concat(val)
    }
  }

  content.forEach((el) => {
    // "* tekst"
    if (isStringNode(el) && isStartsWith(el, '*')) {
      if (listItems[listIdx]) { listIdx++ }
      ensureListItem(createItemNode())
      addItem(el.substr(1))
      return
    }

    // [*]
    if (isTagNode(el) && TagNode.isOf(el, '*')) {
      if (listItems[listIdx]) { listIdx++ }
      ensureListItem(createItemNode())
      return
    }

    // [li]
    if (isTagNode(el) && TagNode.isOf(el, 'li')) {
      if (listItems[listIdx]) { listIdx++ }
      ensureListItem(el)
      return
    }

    // normalny content
    if (listItems[listIdx]) {
      addItem(el)
    } else {
      ensureListItem(el)
    }
  })

  return [].concat(listItems)
}

export default (bbcodes, type) => {
  if (!bbcodes) { return '' }
  let onlyAllowTags = []

  let bbcode = replaceHtmlTags(bbcodes)
  // let bbcode = bbcodes

  if (bbcode && bbcode.length) {
    switch (type) {
      case 'minimal':
        onlyAllowTags = ['b', 'i', 'u', 'center', 'justify', 'left', 'right', 'url']
        bbcode = bbcode.replace(/\[p]/g, '')
        bbcode = bbcode.replace(/\[\/p]/g, '\n')
        break
      default:
        onlyAllowTags = ['p', 'b', 'i', 'li', '*', 'list', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'tr', 'td', 'th', 'center', 'justify', 'left', 'right', 'url', 'quote']
        break
    }

    const preset = presetHTML5.extend((tags, options) => ({
      ...tags,
      b: node => ({
        tag: 'b',
        content: node.content
      }),
      list: (node) => {
        if (node.attrs.numberlist) {
          return {
            tag: 'ol',
            attrs: {
              class: 'numberlist'
            },
            content: asListItems(node.content)
          }
        } else if (node.attrs.bulletlist) {
          return {
            tag: 'ul',
            attrs: {
              class: 'bulletlist'
            },
            content: asListItems(node.content)
          }
        } else if (node.attrs.checklist) {
          return {
            tag: 'ul',
            attrs: {
              class: 'checklist'
            },
            content: asListItems(node.content)
          }
        } else {
          return {
            tag: 'ul',
            content: asListItems(node.content)
          }
        }
      },
      center: node => ({
        tag: 'div',
        attrs: {
          style: 'text-align:center;'
        },
        content: node.content
      }),
      justify: node => ({
        tag: 'div',
        attrs: {
          style: 'text-align:justify;'
        },
        content: node.content
      }),
      left: node => ({
        tag: 'div',
        attrs: {
          style: 'text-align:left;'
        },
        content: node.content
      }),
      right: node => ({
        tag: 'div',
        attrs: {
          style: 'text-align:right;'
        },
        content: node.content
      }),
      table: (node) => {
        if (node.attrs && node.attrs.class && node.attrs.class === 'table') {
          return {
            tag: 'table',
            attrs: {
              class: 'table'
            },
            content: node.content
          }
        } else {
          return {
            tag: 'div',
            attrs: {
              class: 'table-container'
            },
            content: [{
              tag: 'table',
              attrs: {
                class: 'table'
              },
              content: node.content
            }]
          }
        }
      },
      quote: node => ({
        tag: 'div',
        attrs: {
          class: 'blockquote'
        },
        content: node.content
      })
    }))

    const options = {
      onlyAllowTags,
      enableEscapeTags: true
    }

    return bbobHTML(bbcode, preset(), options)
  } else {
    return ''
  }
}
